import classNames from 'classnames';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';
import { CodePreview } from '@/components/global';
import { Button, Icon } from '@/components/standalone';

const codeBlock = `
<head>
  <script src="https://widget.trustblock.run/project-widget.min.js" defer></script>
</head>

<body>
  <div
    data-tb-project-widget
    data-tb-contract-evm-address="0xeda3866f07566d9379a91a07f8d62e19c03183e0"
    data-tb-contract-chain="bnbchain"
    data-tb-color="light"
    data-tb-mode="fit-content" />
</body>
`;

function PlatformsWidgetSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const contentRef = useRef();
  const { isOnScreen: isContentOnScreen } = useOnScreen({
    ref: contentRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div
      className={classNames(
        'section',
        styles.personaeSection,
        styles.personaeSectionCenter,
        styles.personaeSectionGrey,
      )}
    >
      <div className={classNames('max-content-width', styles.classic)}>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag dark">
            <Icon name="Code" />
            USE OUR LABELS
          </div>
          <h2>Maximize engagement</h2>
          <p>
            Easily integrate labels and boost your user experience. Labels
            enhance both security and accessibility by reducing due dilligence
            and increasing user retention.
          </p>
        </div>
        <div
          className={classNames(styles.personaeSectionContent, {
            [styles.personaeSectionContentAppear]: isContentOnScreen,
          })}
          ref={contentRef}
        >
          <div className={styles.personaeSectionResult}>
            <div
              data-tb-project-widget
              data-tb-contract-evm-address="0xeda3866f07566d9379a91a07f8d62e19c03183e0"
              data-tb-contract-chain="bnbchain"
              data-tb-color="light"
              data-tb-mode="fit"
            />
          </div>
          <CodePreview codeBlock={codeBlock} />
          <Button
            type="link"
            href={`${process.env.NEXT_PUBLIC_WEB_URL}/widget/project?evmAddress=0xeda3866f07566d9379a91a07f8d62e19c03183e0&chain=bnbchain&color=light&mode=fit-content`}
            icon="ArrowUpRight"
            mode="primary"
          >
            Try it on our playground
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PlatformsWidgetSection;
